import { withHook } from 'utils/withHook';

import { ReviewsFeedView } from 'containers/ReviewsFeed/view/ReviewsFeedView';
import { useReviewsFeedState } from 'containers/ReviewsFeed/logic/useReviewsFeedState';

export const ReviewsFeed = withHook(useReviewsFeedState)(ReviewsFeedView);
